import React from 'react';

import {DataFrameColumnDef} from 'data-frames/DataFrameTypes';
import {getColumnOptionDatas} from 'insights/analytics-visualizations/configs/config-components/ConfigEditorUtils';
import DropdownSelector from 'insights/analytics-visualizations/configs/form-components/DropdownSelector';
import FieldLabel from 'ui-library/inputs/FieldLabel';

export interface ErrorBarColumnEditorProps<ChartParameters extends {errorBarColumnName?: string | null}> {
  columns: Array<DataFrameColumnDef>;
  parameters: ChartParameters;
  onUpdateParameters: (update: Partial<ChartParameters>) => void;
  useSystemNames: boolean;
  isDisabled?: boolean;
}

export default function ErrorBarColumnEditor<ChartParameters extends {errorBarColumnName?: string | null}>({
  columns,
  onUpdateParameters,
  parameters,
  useSystemNames,
  isDisabled = false,
}: ErrorBarColumnEditorProps<ChartParameters>): JSX.Element {
  return (
    <div className="u-input-spacing-top">
      <FieldLabel label="Error bars" />
      <DropdownSelector
        allowNull={true}
        onChange={(newErrorBarColumnName) => {
          onUpdateParameters({...parameters, errorBarColumnName: newErrorBarColumnName});
        }}
        searchable={true}
        selectedValue={parameters.errorBarColumnName ?? null}
        optionDatas={getColumnOptionDatas(columns, useSystemNames)}
        disabled={isDisabled}
      />
    </div>
  );
}
